var _desc, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFocusOver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "edit-over") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2-Copy",
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#4e565a",
    fillRule: "evenodd"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.428 3.9401c-3.528 0.616-6.272 3.36-6.8879 6.8879h1.4c0.56-2.744 2.744-4.928 5.488-5.488zm2.8 0v1.4c2.744 0.56 4.872 2.744 5.432 5.488h1.4c-0.56-3.528-3.36-6.272-6.8319-6.8879zm-9.6879 9.6879c0.616 3.472 3.36 6.272 6.8879 6.8319v-1.4c-2.744-0.56-4.928-2.688-5.488-5.432zm15.12 0c-0.56 2.744-2.688 4.872-5.432 5.432v1.4c3.472-0.56 6.272-3.36 6.8319-6.8319z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocusOver);
export default __webpack_public_path__ + "static/media/focus-over.a7e93d77fb54c66c1b7357b1c1936989.svg";
export { ForwardRef as ReactComponent };